export const isEmptyString = (value: unknown): boolean => value === '';
